import { TriggerableConfirmationModal } from "components";
import { ModalSizes } from "enums";
import { type IObservable } from "interfaces";
import { useState } from "react";

interface Props {
  observer: IObservable<(onConfirm: () => void, hidden: boolean, ids: number[]) => void>;
  onClose?: () => void;
}

export const FlowsVisibilityModal = (props: Props) => {
  const { observer, onClose } = props;
  const [cfg, setCfg] = useState({ hidden: false, multi: false });
  const entity = cfg.multi ? "flows" : "flow";
  const getContent = () => {
    const course = cfg.multi ? "courses" : "course";

    if (!cfg.hidden) {
      return `This action will make the ${course} undiscoverable for end-users, 
                though their progress will remain intact. Are you sure you want to proceed?`;
    }

    return `This action will make the ${course} discoverable for end-users, 
        allowing them to resume their progress. Are you sure you want to proceed?`;
  };

  return (
    <TriggerableConfirmationModal
      content={getContent()}
      onTriggerModalObserver={observer}
      title={!cfg.hidden ? `Hide ${entity}` : `Show ${entity}`}
      onTrigger={(hidden: boolean, ids: number[]) => {
        setCfg({ hidden, multi: ids.length > 1 });
      }}
      onClose={onClose}
      size={ModalSizes.tiny}
    />
  );
};
